import { lazy } from 'react'

const Home = lazy(() => import('./home/home'))

export { Home }
